<template>
  <el-row class="news-detail pb-100">
    <el-row class="news-banner">
      <img :src="banner" />
    </el-row>
    <lgy-container class="container">
      <p>新闻中心</p>
      <p>INFORMATION CENTER</p>
    </lgy-container>
    <lgy-container class="pt-20">
      <el-row class="pt-40">
        <el-col :span="21" class="pr-100 ql-container">
          <p class="subject">
            {{ data.title }}
          </p>
          <p class="date">
            {{ data.createTime }}
          </p>
          <p class="ql-editor" v-html="data.content"></p>
        </el-col>
        <el-col :span="3">
          <p class="mt-0 title">
            相关分类
          </p>
          <p
            class="btn"
            :class="[type === 1 ? 'choose' : '']"
            @click="toPage(1)"
          >
            平台新闻
          </p>
          <p
            class="btn"
            :class="[type === 2 ? 'choose' : '']"
            @click="toPage(2)"
          >
            行业动态
          </p>
        </el-col>
      </el-row>
    </lgy-container>
  </el-row>
</template>

<script>
import api from '@/http/sys/information'
export default {
  data() {
    return {
      type: 1,
      banner: require('@/assets/img/newsBanner.png'),
      data: {}
    }
  },
  mounted() {
    if (this.$route.query.type) {
      this.type = parseInt(this.$route.query.type)
    }
    this.initData()
  },
  methods: {
    initData() {
      api.getInfoById(this.$route.query.id).then(res => {
        if (res.code === this.sucCode) {
          this.data = res.data
        }
      })
    },
    toPage(type) {
      this.$router.push({
        path: 'news',
        query: {
          type
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.news-detail {
  background: $backColor;
  min-height: 350px;
  .subject {
    margin: 0;
    font-size: 1.5rem;
  }
  .date {
    margin-top: 8px;
    color: #828584;
  }
  .title {
    font-weight: bold;
  }
  .btn {
    text-align: center;
    padding: 14px 0;
    border: 1px solid #e8e8e8;
    color: #828584;
    cursor: pointer;
  }
  .choose {
    background: $primary;
    border: 1px solid $primary;
    color: white;
  }
}
.container {
  position: absolute;
  height: auto;
  top: 8%;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  p {
    &:first-child {
      font-size: 1.875rem;
      font-weight: bold;
      margin-bottom: 0;
    }
    &:last-child {
      margin-top: 5px;
      font-size: 1.25rem;
    }
  }
}
.news-banner {
  img {
    width: 100%;
    min-width: 1200px;
  }
}
</style>
